import { render } from "./UserLanguage.vue?vue&type=template&id=39d3fa0c&scoped=true"
import script from "./UserLanguage.vue?vue&type=script&lang=js"
export * from "./UserLanguage.vue?vue&type=script&lang=js"

import "./UserLanguage.vue?vue&type=style&index=0&id=39d3fa0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d3fa0c"]])

export default __exports__